<template>
  <div class="commonSelect">
    <!-- h5Picker -->
    <van-field
      v-if="$isFlag"
      readonly
      clickable
      name="picker"
      style="border-radius:0"
      :label="selectionInfo.selectName"
      :value="gameName"
      placeholder="点击选择"
      @click="showPicker = true"
    />
    <!-- web下拉 -->
    <div v-else class="selectWebClass">
      <p>{{ selectionInfo.selectName }}</p>
      <el-select v-model="gameVal" clearable placeholder="请选择" @change="onConfirm">
        <el-option
          v-for="(item, i) in selectionInfo.columns"
          :key="item[selectionInfo.val]+i"
          :label="item[selectionInfo.label]"
          :value="item[selectionInfo.val]"
        />
      </el-select>
    </div>
    <!-- h5 popup -->
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="selectionInfo.columns"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      >
        <template #option="option">
          <div style="display: flex; flex-direction: column; align-items: center;">
            <div>{{ option[selectionInfo.label] }}</div>
          </div>
        </template>
      </van-picker>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: 'CommonSelect',
  props: {
    selectionInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }

  },
  data() {
    return {
      gameVal: '',
      gameName: '',
      showPicker: false
    }
  },
  created() {},
  mounted() {
    // this.gameVal = this.selectionInfo.destroyGame
    // this.gameName = this.selectionInfo.columns.find(res => res[this.selectionInfo.label] == this.selectionInfo.destroyGame)[this.selectionInfo.label]
  },
  methods: {
    onConfirm(val) {
      console.log(val, '11111111111111')
      this.showPicker = false
      if (this.$isFlag) {
        this.gameName = val[this.selectionInfo.label]
        this.$emit('emitParentVal', val[this.selectionInfo.label], val[this.selectionInfo.val])
      } else {
        const data = this.selectionInfo.columns.find(el => el[this.selectionInfo.val] == val) || {}
        this.$emit('emitParentVal', data[this.selectionInfo.label], val)
      }
    }
  }
}
</script>
<style lang="stylus" scoped >
@import '~assets/css/accountCommon.styl';

</style>
